
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/buying/payment-process",
      function () {
        return require("private-next-pages/content/buying/payment-process.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/buying/payment-process"])
      });
    }
  